import { useState } from 'react';
import axios from 'axios';
import {
  Input, Tag, Modal, Form, Space, Alert, Checkbox, App as AntApp,
} from 'antd';
import { API_URL } from '../../config';
import type { Grupo } from './types';
import { getToken } from './utils';

// Modal "Criar novo usuário" (Cognito + perfis).
export default function FormNovo({ grupos, onClose, onSaved }: { grupos: Grupo[]; onClose: () => void; onSaved: () => void }) {
  const { message } = AntApp.useApp();
  // Desde 28/09/2026 pessoa da equipe nasce por Permissões › Nova pessoa
  // (login + ficha juntos). Esta porta antiga só cria conta SEM vínculo.
  const [form, setForm] = useState({ email: '', nome: '', senha_temp: 'Hydrodata@2026!', groups: [] as string[], conta_sem_vinculo: false });
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!form.email || !form.nome) { message.warning('E-mail e nome obrigatórios'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      await axios.post(`${API_URL}/admin/usuarios`, form, { headers: { Authorization: token } });
      alert(`Usuário criado!\n\nE-mail: ${form.email}\nSenha temporária: ${form.senha_temp}\n\nInforme ao usuário — ele será forçado a trocar no primeiro login.`);
      onSaved(); onClose();
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.erro || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onClose} onOk={salvar} confirmLoading={salvando} title="Criar novo usuário"
      okText="Criar usuário" cancelText="Cancelar" destroyOnClose>
      <Form layout="vertical" size="small">
        <Alert type="info" showIcon style={{ marginBottom: 10 }}
          message="Pessoa da equipe? Use Administração › Permissões › Nova pessoa: cria o login e a ficha juntos."
          description="Esta tela só cria conta sem vínculo de trabalho (contador, TI, serviço)." />
        <Form.Item>
          <Checkbox checked={form.conta_sem_vinculo} onChange={e => setForm({ ...form, conta_sem_vinculo: e.target.checked })}>
            É uma conta sem vínculo de trabalho
          </Checkbox>
        </Form.Item>
        <Form.Item label="Nome completo" required>
          <Input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} />
        </Form.Item>
        <Form.Item label="E-mail" required>
          <Input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
            placeholder="fulano@hydrodataeng.com.br" />
        </Form.Item>
        <Form.Item label="Senha temporária"
          extra="Mínimo 8 caracteres, 1 maiúscula, 1 minúscula, 1 número, 1 especial. Usuário força troca no 1º login.">
          <Input value={form.senha_temp} onChange={e => setForm({ ...form, senha_temp: e.target.value })} />
        </Form.Item>
        <Form.Item label="Grupos (perfis de acesso)">
          <Space wrap>
            {grupos.map(g => (
              <Tag.CheckableTag key={g.name} checked={form.groups.includes(g.name)}
                onChange={(checked) => setForm(f => ({
                  ...f, groups: checked ? [...f.groups, g.name] : f.groups.filter(x => x !== g.name),
                }))}>
                {g.name}
              </Tag.CheckableTag>
            ))}
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}
